/*
 * the BrregService class handles requests to the Brønnøysundregisteret API
 * http://stackoverflow.com/questions/34755350/using-http-rest-apis-with-angular-2/34758630#34758630 (see accepted answer by Pardeep Jain)
 * http://stackoverflow.com/questions/37290672/passing-parameters-in-http-get-using-angular-2 (see accepted answer by Pardeep Jain)
 * https://angular.io/docs/ts/latest/guide/server-communication.html#!#error-handling
 * by ole fjarestad
 */

import { Injectable } from '@angular/core';
import { Http, Headers, Request, RequestOptions, RequestMethod, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class BrregService {

	private companyUrl: string = 'https://data.brreg.no/enhetsregisteret/enhet';

	constructor(private http: Http) { }

	private getRequestOptions( options ) {
		let headers = new Headers();
		headers.append( 'Accept', 'application/json' );
		options.headers = headers;
		let requestOptions = new RequestOptions(options);
		// console.log( requestOptions );
		return requestOptions;
	}

	private handleError(error: Response | any) {
		return Observable.throw(error);
	}

	getCompany(orgnr: number): Observable<{}> {

		// 913 451 813 = Fjaerestad Web
		// 994 932 691 = Semway Norge AS

		let requestOptions = {
			method: RequestMethod.Get,
			url: this.companyUrl + '/' + orgnr + '.json',
		}

		let company$ = this.http
						.request( new Request(this.getRequestOptions(requestOptions)) )
						// .do( (res: Response) => console.log( res ) )
						.map( (res: Response) => res.json() )
						// .do( (res: Response) => console.log( res ) )
						.catch( this.handleError );
		// console.log(company$);
		return company$;
	}




	// getClient(id: number): Observable<{}> {

	// 	let requestOptions = {
	// 		method: RequestMethod.Get,
	// 		url: this.clientsUrl + '/' + id,
	// 	}

	// 	let client$ = this.http
	// 					.request( new Request(this.getRequestOptions(requestOptions)) )
	// 					// .do( (res: Response) => console.log( res ) )
	// 					.map( (res: Response) => res.json() )
	// 					// .do( (res: Response) => console.log( res ) )
	// 					.catch( this.handleError );

	// 	return client$;
	// }


}



// WEBPACK FOOTER //
// ./src/app/brreg.service.ts